import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import {
  Button, Form, Header, Message,
} from 'semantic-ui-react';
import { clearError as accountClearError, sendSetNewPasswordEmail } from '../modules/account';
import { clearError as sessionClearError, setCredentialData } from '../modules/session';

import CenterCard from './center_card';

import Loading from './loader_wave';
import ErrorMessage from './error_message';

class Forgot extends Component {
  constructor() {
    super();

    this.state = {
      submitted: false,
    };
  }

  componentDidMount() {
    const { connectedAccountClearError, connectedSessionClearError } = this.props;
    connectedAccountClearError();
    connectedSessionClearError();
  }

  componentWillUnmount() {
    const { connectedAccountClearError, connectedSessionClearError } = this.props;
    connectedAccountClearError();
    connectedSessionClearError();
  }

  setCredentialData(event) {
    const { connectedSetCredentialData } = this.props;
    connectedSetCredentialData(event.target.name, event.target.value);
  }

  submitCredentials(event) {
    const { connectedSendSetNewPasswordEmail } = this.props;
    event.preventDefault();
    connectedSendSetNewPasswordEmail();
    this.setState({
      submitted: true,
    });
  }

  renderSubmitArea = () => {
    const { requestOut } = this.props;
    const { submitted } = this.state;

    return (
      <div>
        { submitted && requestOut
          ? <Loading />
          : (
            <Button
              primary
              type="submit"
            >
              Send email
            </Button>
          )}
        <div className="re is-flex is-flex-row is-flex-justify-space-between is-marginTop-16px">
          <Link to="/signin">Sign in</Link>
          {/* <Link to="/create">Sign up</Link> */}
        </div>
      </div>
    );
  }

  renderForm = (email) => (
    <Form className="forgot" onSubmit={(event) => { this.submitCredentials(event); }}>
      <Header>
        Forgot your password?
      </Header>
      <p>
        Let&apos;s verify the account you signed up for:
      </p>
      <Form.Input type="email" name="email" placeholder="Email address" value={email} onChange={(event) => { this.setCredentialData(event); }} required />
      { this.renderSubmitArea() }
    </Form>
  )

  renderSuccessMessage = (email) => (
    <>
      <p>
        We&apos;ve sent an email to
        {' '}
        <b>{email}</b>
        {' '}
        to verify your account.
      </p>
      <Message positive>
        <p>
          Please check your inbox, and possibly your spam folder.
        </p>
      </Message>
    </>
  )

  render() {
    const {
      email,
      error,
      requestOut,
      routeName,
    } = this.props;
    const { submitted } = this.state;
    return (
      <CenterCard routeName={routeName}>
        { (submitted && !requestOut && !error)
          ? this.renderSuccessMessage(email)
          : this.renderForm(email) }
        { error && <ErrorMessage message="Unable to send a set new password email to the provided email." /> }
      </CenterCard>
    );
  }
}

Forgot.propTypes = {
  connectedAccountClearError: PropTypes.func.isRequired,
  connectedSendSetNewPasswordEmail: PropTypes.func.isRequired,
  connectedSessionClearError: PropTypes.func.isRequired,
  connectedSetCredentialData: PropTypes.func.isRequired,
  email: PropTypes.string.isRequired,
  error: PropTypes.shape({}),
  requestOut: PropTypes.bool.isRequired,
  routeName: PropTypes.string.isRequired,
};

Forgot.defaultProps = {
  error: undefined,
};

const mapStateToProps = (state) => ({
  email: state.session.email,
  error: state.account.error,
  requestOut: state.account.setNewPasswordEmailRequestOut,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
  connectedAccountClearError: accountClearError,
  connectedSendSetNewPasswordEmail: sendSetNewPasswordEmail,
  connectedSessionClearError: sessionClearError,
  connectedSetCredentialData: setCredentialData,
}, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Forgot);
